import * as React from 'react';
const CustomDnbOperational = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g data-name="Layer 2">
      <path
        fill="#26b382"
        fillRule="evenodd"
        d="M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m4.15-9.27a.5.5 0 0 0-.71-.73L6.13 8.33 3.85 6.06a.5.5 0 0 0-.7 0 .5.5 0 0 0 0 .71L5.77 9.4a.51.51 0 0 0 .71 0z"
        data-name="Layer 1"
      />
    </g>
  </svg>
);
export default CustomDnbOperational;
